import { useMemo } from "react";
import { brand } from "../../theme";

const CONFETTI_COLORS = [
  brand.amber,
  "#E8741A",
  "#F5D873",
  brand.white,
  brand.amberDeep,
] as const;

const CONFETTI_PIECE_COUNT = 14;

/** Animated celebration overlay shown above the slot reels on the reveal
 *  phase. Dimensions / colors match the v11 design spec exactly. */
const ConfettiLayer = () => {
  const pieces = useMemo(() => {
    return Array.from({ length: CONFETTI_PIECE_COUNT }).map((_, i) => ({
      key: i,
      left: `${(i * 7 + 5) % 95}%`,
      width: 6 + (i % 3) * 2,
      height: 8 + (i % 2) * 4,
      background: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
      duration: 1.6 + (i % 4) * 0.3,
      delay: (i % 5) * 0.1,
    }));
  }, []);

  return (
    <div className="confetti-layer" aria-hidden>
      {pieces.map((p) => (
        <span
          key={p.key}
          className="confetti-piece"
          style={{
            left: p.left,
            width: p.width,
            height: p.height,
            background: p.background,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
};

export default ConfettiLayer;
